export default "__VITE_ASSET__DZj8$ZOD__"